import ServiceHistoryPanel from 'src/components/ConnectedVehicle/ServiceHistory/ServiceHistoryPanel/ServiceHistoryPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(ServiceHistoryPanel);